import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { attSubPage } from 'decorators/subPage';
import { activateSub } from 'actions/attSubs';
import {
  getSubmitStatus,
  getAttActivationResponse,
  getIsAdmin,
  getIncludedInGroups,
} from 'reducers';
import { generatePinSync as generatePin } from 'secure-pin';
import ActivationForm from 'components/ActivationForm/att';

const pin = generatePin(4);

const mapStateToProps = (state, { subId, sub }) => ({
  initialValues: { pin, bypass_att: true },
  saveStatus: getSubmitStatus(state, 'activateAttSub'),
  activationResponse: getAttActivationResponse(state, subId),
  isAdmin: getIsAdmin(state),
  isAgent: getIncludedInGroups(state, ['AGENT']),
  isManager: getIncludedInGroups(state, ['MANAGER']),
});

const mapDispatchToProps = (dispatch, { subId }) => ({
  onSubmit: (values) => dispatch(activateSub(subId, values)),
  remoteSubmit: () => dispatch(submit('activateAttSub')),
});

export default attSubPage(
  connect(mapStateToProps, mapDispatchToProps)(ActivationForm),
);
